import { AxiosInstance } from 'axios';
import { Result } from 'util/result';
import { apiResult } from 'util/apiResult';
import {
  SyncIamServiceIntegrationConfigRequest,
  SyncTrackingServiceIntegrationConfigRequest,
  SyncPaymentServiceIntegrationConfigRequest,
  SyncNotificationServiceIntegrationConfigRequest,
  SyncLoyaltyServiceIntegrationConfigRequest,
} from 'data/terra_bff/ServiceIntegrationConfig';

class ServiceIntegrationEndpoint {
  getSyncIamServiceIntegrationConfigUrl = () =>
    `api/v1/service-integrations/iam/configs/sync`;
  getSyncTrackingServiceIntegrationConfigUrl = () =>
    `api/v1/service-integrations/tracking/configs/sync`;
  getSyncLoyaltyServiceIntegrationConfigUrl = () =>
    `api/v1/service-integrations/loyalty/configs/sync`;
  getSyncPaymentServiceIntegrationConfigUrl = () =>
    `api/v1/service-integrations/payment/configs/sync`;
  getSyncNotificationServiceIntegrationConfigUrl = () =>
    `api/v1/service-integrations/notification/configs/sync`;
}

export class ServiceIntegrationApi {
  terraClient: AxiosInstance;
  endpoint = new ServiceIntegrationEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  syncIamServiceIntegrationConfig(
    request: SyncIamServiceIntegrationConfigRequest
  ): Promise<Result<void>> {
    return apiResult(
      async () =>
        (
          await this.terraClient.post<void>(
            this.endpoint.getSyncIamServiceIntegrationConfigUrl(),
            request
          )
        ).data
    );
  }

  syncTrackingServiceIntegrationConfig(
    request: SyncTrackingServiceIntegrationConfigRequest
  ): Promise<Result<void>> {
    return apiResult(
      async () =>
        (
          await this.terraClient.post<void>(
            this.endpoint.getSyncTrackingServiceIntegrationConfigUrl(),
            request
          )
        ).data
    );
  }

  syncLoyaltyServiceIntegrationConfig(
    request: SyncLoyaltyServiceIntegrationConfigRequest
  ): Promise<Result<void>> {
    return apiResult(
      async () =>
        (
          await this.terraClient.post<void>(
            this.endpoint.getSyncLoyaltyServiceIntegrationConfigUrl(),
            request
          )
        ).data
    );
  }

  syncPaymentServiceIntegrationConfig(
    request: SyncPaymentServiceIntegrationConfigRequest
  ): Promise<Result<void>> {
    return apiResult(
      async () =>
        (
          await this.terraClient.post<void>(
            this.endpoint.getSyncPaymentServiceIntegrationConfigUrl(),
            request
          )
        ).data
    );
  }

  syncNotificationServiceIntegrationConfig(
    request: SyncNotificationServiceIntegrationConfigRequest
  ): Promise<Result<void>> {
    return apiResult(
      async () =>
        (
          await this.terraClient.post<void>(
            this.endpoint.getSyncNotificationServiceIntegrationConfigUrl(),
            request
          )
        ).data
    );
  }
}
